module.exports = __webpack_public_path__ + "resources/img/img_dataquery_jp.2b7eca8c5d36409b4cfa1fd2f9701a46.png";